<template>
  <o-view :has-white-background="true" :no-scroll="true" :flex="true">
    <o-nav-bar
      title="Je verzekering"
      :has-back-button="true"
      :has-close-button="true"
    />
    <o-embed
      url="https://www.olympus-mobility.be/nl/contractuele-en-algemene-voorwaarden/"
    />
    <o-bottom-buttons>
      <template #buttons>
        <o-button
          :is-secondary="true"
          to="/sales/car/cambio/reservations/new-summary"
          label="Nee, ik wil enkel basisdekking"
        />
        <o-button
          :is-primary="true"
          to="/sales/car/cambio/reservations/new-summary"
          label="Ja, ik wil deze volledige dekking"
        />
      </template>
    </o-bottom-buttons>
  </o-view>
</template>

<script>
import OBottomButtons from '@/components/base/OBottomButtons.vue'
import OEmbed from '@/components/base/OEmbed.vue'
export default {
  name: 'CambioEdit',
  components: { OEmbed, OBottomButtons }
}
</script>
